import { Component } from '@angular/core';
import { MainStatisticsComponent } from "../../statistics/main-statistics/main-statistics.component";

@Component({
  selector: 'app-main-admin',
  imports: [MainStatisticsComponent],
  templateUrl: './main-admin.component.html',
  styles: ``
})
export class MainAdminComponent {
  showFilters: boolean = false;

  showFilter(): void {
    this.showFilters = !this.showFilters;
  }
}
